<template>
    <section class="mt-16">
      <v-breadcrumbs
          v-if="this.$root.$vuetify.theme.isDark"
          large
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
        <v-breadcrumbs
          v-else
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-hard-hat</v-icon> <span>{{$t('chapter_class.crumb_edit')}}</span>
        </h1>
  
        <div class="mt-16">
          <v-progress-linear v-if="loading"
            indeterminate
            class="global-loader"
          ></v-progress-linear>
  
          <template v-if="loading">
            <v-row>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row class="mt-6" align="center" justify="space-around">
              <v-skeleton-loader
                  type="button"
                ></v-skeleton-loader>
            </v-row>
          </template>
          <ChapterClass v-else method="update" :chapter_class="chapter_class" @refresh="refresh" :style="this.$root.$vuetify.theme.isDark ? '' : 'background-color: rgba(255, 255, 255, 0.75) !important;'">
        </ChapterClass>
        </div>
    </section>
  </template>
  <script>
  import ChapterClass from '@/components/chapter-class/ChapterClass'
  import ChapterClassAPI from "@/api/ChapterClass.js";
  
  export default {
    components: {
        ChapterClass
    },
    beforeCreate(){
      document.title = "Report Lake - " + this.$t('chapter_class.crumb_edit');
    },
    data: () => ({
        chapter_class: {},
        loading:true
    }),
    mounted(){
      if(!this.$root.session.hasPermission(["super", "class.update"])) {
        this.$router.push('/admin');
      }
  
      ChapterClassAPI.find(this.$route.params.id).then(({data}) => { this.chapter_class = data; this.loading = false;});
    },
    methods:{
      refresh(){
        ChapterClassAPI.find(this.$route.params.id).then(({data}) => { this.chapter_class = data; this.loading = false;});
      }
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: this.$t('menu.dashboard'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin',
            exact: true,
          },
          {
            text: this.$t('menu.chapter_class'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin/elements/chapters-class',
            exact: true,
          },
          {
            text: this.$t('chapter_class.crumb_edit'),
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  